import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BasketDiscountType, CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { Typography } from 'common/typography';

import { BasketDiscountFormValues } from '../../../types';
import { CampaignsTargetContent } from '../../../utils/telemetry/constants';
import {
  telemetryNewCampaignInteractionClickCampaignRules,
  telemetryUpdateCampaignInteractionClickCampaignUpdate,
} from '../../../utils/telemetry/telemetry';
import CampaignFormItem from '../../CampaignFormItem';
import CustomRadioCard from '../../CustomRadioCard';
import { basketDiscountTypeOptions } from '../../forms/BasketDiscountForm/basketDiscountTypeOptions';

export type BasketDiscountTypeFormItemProps = {
  'data-test-id'?: string;
  campaignType: CampaignType;
  isNewCampaignRoute?: boolean;
  isDisabled?: boolean;
  onChange?: (discountType: BasketDiscountType) => void;
};

const StyledRadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px;
  padding-block-start: 4px;
`;

export const BasketDiscountTypeFormItem = ({
  campaignType,
  onChange,
  isNewCampaignRoute,
  isDisabled,
  ...props
}: BasketDiscountTypeFormItemProps) => (
  <CampaignFormItem
    data-test-id={props['data-test-id']}
    title={<FormattedMessage id="campaigns.discount-type.section-title" />}
    value={
      <StyledRadioGroup>
        {Object.entries(basketDiscountTypeOptions).map(([discountType, translationId]) => (
          <Field<BasketDiscountFormValues['discountType']>
            name="discountType"
            type="radio"
            value={discountType as BasketDiscountType}
            key={discountType}
          >
            {({ input }) => (
              <CustomRadioCard
                {...input}
                onChange={() => {
                  input.onChange(input.value);
                  onChange?.(input.value);

                  if (isNewCampaignRoute) {
                    telemetryNewCampaignInteractionClickCampaignRules(
                      CampaignsTargetContent.NEW.BASKET_DISCOUNT_TYPE,
                      campaignType,
                    );
                  } else {
                    telemetryUpdateCampaignInteractionClickCampaignUpdate(
                      CampaignsTargetContent.EDIT.BASKET_DISCOUNT_TYPE,
                      campaignType,
                    );
                  }
                }}
                inputProps={{
                  disabled: isDisabled,
                }}
              >
                <Typography.Body3>
                  <FormattedMessage id={translationId} />
                </Typography.Body3>
              </CustomRadioCard>
            )}
          </Field>
        ))}
      </StyledRadioGroup>
    }
  />
);
